import { useQuery } from 'react-query';
import { getFAQs } from '../utils';

const FAQ_QUERY_KEY = 'faq';

export const useQueryFAQ = (requestUrl: string, queryOptions = {}) => {
  return useQuery([FAQ_QUERY_KEY, requestUrl], () => fetch(requestUrl).then(res => res.json()), {
    ...queryOptions,
    // @ts-ignore
    enabled: queryOptions.enabled && Boolean(requestUrl),
    select: data => {
      // @ts-ignore
      const { select } = queryOptions;

      if (select) {
        return getFAQs(select(data));
      }

      return getFAQs(data);
    },
  });
};
